import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput, IonSpinner } from "@ionic/react"
import Head from "../../Header";
import Sidebar from "../../Sidebar";
import DataTable from "react-data-table-component";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import service from "../../../Service/service";
import swal from 'sweetalert';
import "../../../theme/style2.css"
import { Modal } from "react-bootstrap";
import { useLocation } from 'react-router-dom';

const TPDashboard: React.FC = () => {
  const [business, setBusiness] = useState("");
  const [modalopen, setModalopen] = useState(false);
  const [department, setDepartment] = useState("");
  const [businessUnitArr, setBusinessUnitArr] = useState([]);
  const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
  const [timeSheets, setTimeSheets] = useState([])
  const [selectedEmployeeName, setSelectedEmployeeName] = useState("");
  const [selectedEmployecode, setSelectedEmployecode] = useState("");
  const history = useHistory();
  const [roleuser] = useState(localStorage.getItem("UserRole"));
  const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
  const [Id] = useState(localStorage.getItem("SignupEmpId"));
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  useEffect(() => {
    if (Id === null) {
      history.push("/login");
    }
  }, [Id, history]);

  useEffect(() => {
    PendingEmployee();
  }, []);

  const closemodal = () => {
    setModalopen(false);
  }

  const View = (timeSheetsData: any, employeeName: any, employeeId: any) => {
    setTimeSheets(timeSheetsData);
    setSelectedEmployeeName(employeeName);
    setSelectedEmployecode(employeeId);
    setModalopen(true);
    console.log("Employee Name:", employeeName);
    console.log("Employee ID:", employeeId);
  }

  //*******************Getall Datatable***************//

  const columns: any = [
    {
      name: "S.No",
      selector: (itm: any, i: any) => i + 1,
      sortable: true,
      width: "100px",
    },
    {
      name: "Manager Name",
      selector: (itm: any) => itm.managerName,
      sortable: true,
      sort: 'managerName',
      width: "300px",
      cell: (itm: any) => (
        <div>{itm.managerName} ({itm.managerId})</div>
      ),
    },
    {
      name: "BU&DU",
      selector: (itm: any) => itm.masterDepartment.departmentName,

      sortable: true,
      sort: "departmentName",
      width: "320px",
      cell: (itm: any) => (
        <div>{itm.masterDepartment.departmentName}/{itm.businessUnit.businessUnitName}</div>
      )
    },
    {
      name: "Employee Name",
      selector: (itm: any) => itm.employeeName,

      sortable: true,
      sort: "employeeName",
      width: "250px",
      cell: (itm: any) => (
        <div>{itm.employeeName} ({itm.employeeId})</div>
      )
    },
    {
      name: "Weeks",
      selector: (itm: any) => itm.week,
      sortable: true,
      width: "150px"
    },
    {
      name: "Action",
      sortable: false,
      cell: (itm: any) => (
        <div style={{ textDecoration: 'underline', textDecorationColor: "coral", textUnderlinePosition: "under" }}>
          <IonText onClick={() => View(itm.timeSheets, itm.employeeName, itm.employeeId)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
        </div>
      )
    }
  ];

  const customStyles = {
    headRow: {
      style: {},
    },
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "15px",
        justifyContent: "center"
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        justifyContent: "center"
      }
    }
  };

  //*******************Search Filter****************//

  const datatable = data.filter(
    (item: any) =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1
  );

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };
  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }

    };

    return (
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex" }}>
          <div className="form-group form-focus row">
            <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
              value={filterText} placeholder="Search" />
            <label className="focus-label">Search</label>
          </div>
          <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
        </div>
      </div>
    )

  }, [filterText, resetPaginationToggle]);

  //*******************Pending Employee Api***************//

  const PendingEmployee = () => {
    setIsLoading(true);
    service.EmployeeTimesheetPending(Id)
        .then((response) => {
            console.log(response);
            console.log("Employee List", response.data.Data);
            if (response.data.Status === "200") {
                setData(response.data.Data);
                setTimeSheets(response.data.timeSheets);
            } else {
                setData([]);
            }
        })
        .catch((error) => {
            swal(error);
        })
        .finally(() => {
            // This code will execute whether the promise is resolved or rejected
            setTimeout(() => {
                setIsLoading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
            }, 1000); // Adjust the timeout duration as needed
        });
};

  //*******************Pdf Api************//

  const Generatepdf = () => {
    setIsLoading(true);

    setTimeout(() => {
      // Begin PDF generation process
      service.EmployeeGeneratePdf(Id)
        .then((response) => {
          console.log(response);
          console.log("Pdf", response.data.Data);
          if (response.data.Status === "200") {
            setData(response.data.Data);

            const blob = new Blob([response.data.Data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'generated_pdf.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else {
            setData([]);
          }
        })
        .catch((error) => {
          swal(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }, 1500);
  };
  const back = () => {
    history.goBack();
  }

  return (
    <IonPage>
      <Head />
      <Sidebar />
      <IonContent>
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title"> <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "2px" }} /> Dashboard </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item active">Timesheet Approval Pending</li>
                </ul>
              </div>
            </div>
          </div>
          <Modal dialogClassName="modal-dialog modal-lg" show={modalopen}>
            <div className="modal-header">
              <h5 className="modal-title"> {selectedEmployeeName} ({selectedEmployecode}) - Timesheet Approval Pending </h5>
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group" style={{ marginTop: "2%" }}>
                  <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                    {timeSheets && timeSheets.length > 0 && timeSheets.map((itm: any) => (
                      <li key={itm.id}>{itm}</li>
                    ))}
                  </div>
                </div>
              </form>
            </div>
          </Modal>
          <div className="col-sm-6  col-lg-6" style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <button
              onClick={Generatepdf}
              className="btn btn-success btn-block"><i className="la la-file-pdf-o" />
              Generate pdf
            </button>
          </div>
          {isLoading && (
            <div
              style={{
                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
              }}
            >
              <div >
                <IonSpinner style={{
                  width: "40px",
                  height: "40px",
                  color: "#ff8a53"

                }} name="lines" />
              </div>
            </div>
          )}
          <div style={{ marginTop: '2%' }} className="table-responsive">

            <DataTable
              columns={columns}
              data={datatable}
              pagination
              paginationPerPage={10}
              paginationComponentOptions={paginationComponentOptions}
              paginationRowsPerPageOptions={[10, 20, 30]}
              subHeader
              subHeaderComponent={subHeaderComponent}
              customStyles={customStyles}
            />
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}
export default TPDashboard;

